





































































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem, PostFileData } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import MobileSwitchCam from "@/components/MobileSwitchCam";
import RecordStoryButton from "../../../components/RecordStoryButton";

export default defineComponent({
  name: "ActionsStoryController",
  components: { BaseMenu, MobileSwitchCam, RecordStoryButton, BaseIconButton },
  props: {
    isMuted: { type: Boolean },
    isRecording: { type: Boolean },
    showEditButton: { type: Boolean },
    showVolumeController: { type: Boolean },
    addedFile: { type: Object as PropType<PostFileData> },
    storyRecordType: { type: String as PropType<"photo" | "video"> },
    localVideoTracks: { type: Array as PropType<MediaStreamTrack[]>, required: true },
  },
  setup(props) {
    const hasAddedFile = computed(() => !!props.addedFile);
    const uploadLoading = computed(() => !!props.addedFile && props.addedFile.uploadProgress !== 100);

    const menuItems = computed<BaseMenuItem[]>(() => [
      {
        name: "back",
        text: $t("Go back"),
      },
      {
        name: "close",
        text: $t("Close and save draft"),
      },
    ]);

    return { hasAddedFile, uploadLoading, menuItems };
  },
});
